/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Credit_Notes_Reminders_OverInputs */

const en_queue_credit_notes_reminders_over = /** @type {(inputs: Queue_Credit_Notes_Reminders_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit notes not sent after the reminders`)
};

/**
* | output |
* | --- |
* | "Credit notes not sent after the reminders" |
*
* @param {Queue_Credit_Notes_Reminders_OverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_credit_notes_reminders_over = /** @type {((inputs?: Queue_Credit_Notes_Reminders_OverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Credit_Notes_Reminders_OverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_credit_notes_reminders_over(inputs)
});